import { Box, Grid, ListItemText, MenuItem, Tooltip, Chip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const BACKGROUND_COLOR = '#4051B5';
const useStyles = makeStyles((theme) => ({
  sideNav: {
    '&:hover': {
      color: BACKGROUND_COLOR
    },
    '&:hover .menuItem': {
      color: BACKGROUND_COLOR
    },
    '&:hover .icon': {
      color: BACKGROUND_COLOR
    },
    '&:hover .typography': {
      color: BACKGROUND_COLOR
    }
  },
  menuItem: {
    justifyContent: 'start',
    alignContent: 'start',
    alignItems: 'start',
    margin: 0,
    minWidth: 220
  },
  icon: {
    '&:hover': {
      color: BACKGROUND_COLOR
    },
    paddingTop: 3
  },
  listItemText: {
    alignText: 'left',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
}));

const SideNavItem = ({ item, filter, total, folderKey, isPersonal = false }) => {
  const classes = useStyles();

  return (
    <>
      {(
        <Chip
          label={`${item[0]?.reportTag} (${(total) || 0})`}
          clickable
          sx={(() => {
            const base = {
              cursor: 'pointer',
              mr: 2,
              bgcolor: 'transparent',
              '& .MuiChip-label': {
                fontWeight: 400,
                fontSize: '12px',
                color: '#000',
                lineHeight: '1.5rem',
                fontFamily: 'Noto Sans, sans-serif',
                fontStyle: 'normal',
                borderRadius: '1.5rem',
                border: '1px solid #71767A',
                bgcolor: 'transparent',
                padding: '0.3rem 1rem'
              },
              '&:hover': {
                border: '1px solid #001A47'
              }
            };
            if (folderKey !== item[0]?.reportTag && !isPersonal) return base;
            return {
              ...base,
              bgcolor: 'rgba(47, 84, 165, 0.20)',
              '& .MuiChip-label': {
                fontWeight: 600,
                fontSize: '12px',
                color: '#2F54A5',
                lineHeight: '1.5rem',
                fontFamily: 'Noto Sans, sans-serif',
                fontStyle: 'normal',
                borderRadius: '1.5rem',
                border: '1px solid #2F54A5',
                bgcolor: 'rgba(47, 84, 165, 0.20)',
                padding: '0.3rem 1rem'
              }
            };
          })()}
          onClick={() => filter(item[0]?.reportTag)}
        />
      )}
    </>
  );
};

export default SideNavItem;
